import { call, put, takeLatest } from 'redux-saga/effects';

import * as htmlCodeActions from './htmlCodeActions.js';
import { updateHTMLCodeApiCall } from './htmlCodeAPI.js';

function* updateHTMLCodeSaga({ payload }) {
  try {
    const { data } = yield call(updateHTMLCodeApiCall, payload);
    yield put(htmlCodeActions.htmlCodeUpdateStore(data));
  } catch (error) {
    yield put(htmlCodeActions.htmlCodeUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* htmlCodeWatcher() {
  yield takeLatest(htmlCodeActions.htmlCodeUpdateRequest.type, updateHTMLCodeSaga);
}
